import React from 'react';
import { MapPin, PlusCircle, Menu, ExternalLink } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  return <header className="sticky top-0 z-50 w-full border-b bg-white shadow-sm" data-id="element-100">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between gap-4" data-id="element-101">
        {/* Logo & Location */}
        <div className="flex items-center gap-6" data-id="element-102">
          <a href="#" className="flex items-center gap-2" data-id="element-103">
            <img src="https://cdn.magicpatterns.com/uploads/bitF4Fp2Mn5F2xN1PkGCY5/locanto_color.svg" alt="Locanto" className="h-8" data-id="element-104" />
          </a>

          <div className="hidden md:flex items-center text-gray-600 text-sm hover:text-[#00897B] cursor-pointer transition-colors" data-id="element-105">
            <MapPin className="h-4 w-4 mr-1" data-id="element-106" />
            <span data-id="element-107">Singapore</span>
          </div>
        </div>

        {/* Enter Website Button - Desktop */}
        <div className="hidden md:flex flex-1 max-w-xl mx-auto justify-center" data-id="element-108">
          <a href="https://www.geylang777-2.site" target="_blank" rel="noopener noreferrer" data-id="element-109">
            <Button variant="default" className="gap-2 px-6" data-id="element-110">
              <ExternalLink className="h-4 w-4" data-id="element-111" />
              Enter Website
            </Button>
          </a>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3" data-id="element-112">
          <Button variant="ghost" className="hidden md:flex text-gray-600 hover:text-[#00897B]" data-id="element-113">
            Log in
          </Button>
          <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" data-id="element-114">
            <Button variant="orange" className="gap-2 shadow-sm" data-id="element-115">
              <PlusCircle className="h-4 w-4" data-id="element-116" />
              <span className="hidden sm:inline" data-id="element-117">Post Free Ad</span>
              <span className="sm:hidden" data-id="element-118">Post</span>
            </Button>
          </a>
          <Button variant="ghost" size="icon" className="md:hidden" data-id="element-119">
            <Menu className="h-6 w-6 text-gray-600" data-id="element-120" />
          </Button>
        </div>
      </div>

      {/* Mobile Enter Website Button */}
      <div className="md:hidden px-4 pb-3" data-id="element-121">
        <a href="https://www.geylang777-2.site" target="_blank" rel="noopener noreferrer" className="block" data-id="element-122">
          <Button variant="default" className="w-full gap-2" data-id="element-123">
            <ExternalLink className="h-4 w-4" data-id="element-124" />
            Enter Website
          </Button>
        </a>
      </div>
    </header>;
}